import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const docsCardFn = /* @__PURE__ */ createRecipe('docs-card', {}, [])

const docsCardVariantMap = {}

const docsCardVariantKeys = Object.keys(docsCardVariantMap)

export const docsCard = /* @__PURE__ */ Object.assign(memo(docsCardFn.recipeFn), {
  __recipe__: true,
  __name__: 'docsCard',
  __getCompoundVariantCss__: docsCardFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: docsCardVariantKeys,
  variantMap: docsCardVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, docsCardVariantKeys)
  },
  getVariantProps: docsCardFn.getVariantProps,
})